import React from 'react';

import {OrderReviewTotalsSegmentsType} from 'desktop/types/orderReviewTotalsType';
import {ShippingMethodType} from 'types/shippingMethodsType';

/**
 * Change totals for order review with new shipping method
 * @param {OrderReviewTotalsSegmentsType[]} currentTotals - current totals
 * @param {OrderReviewTotalsSegmentsType} shippingMethod - new shipping method
 * @returns {OrderReviewTotalsSegmentsType[]} new totals with new shipping method
 */
export const getOrderReviewTotalsWithNewShipping = (
    currentTotals: OrderReviewTotalsSegmentsType[],
    shippingMethod?: ShippingMethodType,
) => {
    const totalsAsObject: {[key: string]: OrderReviewTotalsSegmentsType} = currentTotals.reduce(
        (acc, total) => ({...acc, [total.code]: total}),
        {},
    );

    if (shippingMethod) {
        totalsAsObject.shipping = {
            area: null,
            code: 'shipping',
            price: Number(shippingMethod.price),
            title: (
                <>
                    Shipping & Handling:
                    {shippingMethod.title && (
                        <>
                            <br />({shippingMethod.title}
                            {shippingMethod.description && ` - ${shippingMethod.description}`})
                        </>
                    )}
                </>
            ),
        };
    }

    if (totalsAsObject.discount?.title) {
        totalsAsObject.discount = {
            ...totalsAsObject.discount,
            title: String(totalsAsObject.discount.title).replace(/Discount:?/gi, 'Discount:'),
        };
    }

    return Object.values(totalsAsObject).sort((a, b) => {
        if (Boolean(a.area) < Boolean(b.area)) {
            return -1;
        }
        if (Boolean(a.area) > Boolean(b.area)) {
            return 1;
        }
        return 0;
    });
};
